import { gql } from '@apollo/client'

export const faqItemFragment = gql`
  fragment faqItem on FaqItem {
    id
    answer
    category
    question
  }
`
